// extracted by mini-css-extract-plugin
export default {"navigation-container":"navigationDetails_navigation-container__yRRvj","navigation-line":"navigationDetails_navigation-line__jcI+Z"};